import React from "react";
import { useAppSelector } from "../../app/hooks";
import { ProfileJumbotron } from "./Profile.elements";
import { Banner } from "../../utils/components/Common";

const Profile = (): JSX.Element => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const user = useAppSelector((state) => state.user.user);

  return (
    <>
      {user && isLoggedIn ? (
        <ProfileJumbotron user={user} isLoggedIn={isLoggedIn}>
          <Banner
            heading="Protected Route"
            message="This is a protected route. Accessible only for authenticated users."
          />
        </ProfileJumbotron>
      ) : null}
    </>
  );
};

export default Profile;
